import { axios } from 'utils/axios';

type NotificationParams = {
  backInStockUrl: string;
  email: string;
  variantId: string;
};

type CreateBackInStockSubscriptionResponse = {
  message: 'ok';
};

/**
 * Create a back in stock subscription
 * @param {NotificationParams} params
 * @returns {Promise<CreateBackInStockSubscriptionResponse>}
 */
export const createBackInStockSubscription = ({
  backInStockUrl,
  email,
  variantId,
}: NotificationParams): Promise<CreateBackInStockSubscriptionResponse> => {
  return axios
    .post<CreateBackInStockSubscriptionResponse>(
      backInStockUrl,
      {
        email: email,
        variant_id: variantId,
      },
      { isPdexApi: true }
    )
    .then((res) => res.data);
};
